import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import { useMediaQuery, Grid2 as Grid, Typography, Box, Card, CardContent, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { SectionHeader } from 'components/molecules';

import Link from '@mui/material/Link';

const useStyles = makeStyles(() => ({
  image: {
    maxWidth: 420,
    borderRadius: '24px',
  },
}));


const data = [
  { title: (
      <>
        Email us at{' '}
        <Link href="mailto:contact@mindsclik.com">
          contact@mindsclik.com
        </Link>
      </>
    )},
  { title: "Schedule a free consultation call" },
  { title: "Share your business details" },
  { title: "We handle the rest!" }
]


const TrustedPartner = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid
        container
        justify="space-between"
        spacing={isMd ? 4 : 2}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          justify="flex-start"
          size={{ xs: 12, md: 6 }}
          data-aos={'fade-up'}
        >
          <div>
            <SectionHeader
              title="Ready to Transform Your Business with ONDC?"
              subtitle=" "
              align="left"
              disableGutter
              subtitleProps={{
                color: 'textPrimary',
                variant: 'body1',
              }}
            />
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              Let Mperito handle the technical complexity while you focus on what you do best - running your business and delighting customers.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              Our end-to-end solution ensures you'll be selling across India's most exciting digital marketplace with minimal effort and maximum results.
            </Typography>
            {/* <Typography
              variant="h6"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }} 
              color="textPrimary"
              className=""
            >
              That was the starting point of MindsClik…
            </Typography> */}
          </div>
        </Grid>
        <Grid
          item
          container
          justify={isMd ? 'flex-end' : 'flex-start'}
          alignItems="center"
          size={{ xs: 12, md: 6 }}
          data-aos={'fade-up'}
        >
          <Box
            component={Card}
            width={1}
            height={1}
            display={'flex'}
            flexDirection={'column'}
            sx={{ backgroundImage: 'none' }}
          >


            <CardContent>
              <Typography
                variant={'h6'}
                gutterBottom
                align={'left'}
                sx={{ fontWeight: 700 }}
              >
                Getting Started is Simple
              </Typography>
              <List disablePadding>
                {data.map((item, index) => (
                  <ListItem disableGutters key={index} data-aos="fade-up">
                    <ListItemAvatar className={classes.listItemAvatar}>
                      <Typography variant='body1' className={classes.bulletNumber}>{index + 1}.</Typography>
                    </ListItemAvatar>
                    <ListItemText className={classes.listItemText} primary={item.title} />
                  </ListItem>
                ))}
              </List>
              <Typography
                variant={'subtitle2'}
                gutterBottom
                align={'left'}
                sx={{
                  fontStyle: 'italic',
                  color: 'primary.main',
                }}
              >
                Join India's digital commerce revolution today!
              </Typography>

            </CardContent>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

TrustedPartner.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default TrustedPartner;
